/* eslint-disable import/no-anonymous-default-export */
import { ENDPOINT } from "../../config";
import { fetchFromLawfeed } from "../../fetchFromLawfeed";

export default async (userId, folderName, caseId, parentFolderId) =>
    await fetchFromLawfeed(
        {
            endpoint: ENDPOINT.FOLDER,
            routeParams: [userId], 
            body: { 
                folderName,
                ...(caseId !== null ? { caseId } : {}),
                ...(parentFolderId != null ? { parentFolderId } : {}),
            }
        }
    );